module.exports = __webpack_public_path__ + "atomic/_patterns/molecules/nav/_nav-simplify-item.twig";